import { IAreaItem } from "./area";

export interface IAuthObjItem {
    schoolId: string;
    schoolName: string;
    type: number;
}

export interface ISchoolItem {
    id: string;
    school_name: string;
    areaName:string;
    provinceid:string;
    cityid:string;
    districtid:string;
    province_name:string;
    city_name:string;
    district_name:string;
    admin_names:string;
    system_code:string;
    sysytem_name:string;
}

export interface IAuthSchoolItem extends ISchoolItem {
    isChoice: number;
}

export interface ISchoolTable {
    page: number;
    limit: number;
    page_count: number;
    total_rows: number;
    rows: IAuthSchoolItem [];
}

export interface IPlatFormItem {
    id: string;
    platformName: string;
    platformState: number;
    regionPlatformType: number;
    provinceId: string;
    cityId: string;
    districtId: string;
    provinceName: string;
    cityName: string;
    districtName: string;
    isChoice: number;
    createDate: number;
}

export interface IPlatFormsTable {
    page: number;
    limit: number;
    page_count: number;
    total_rows: number;
    rows: IPlatFormItem [];
}

export interface ISchoolState {
    provinceId: string;
    cityId: string;
    districtId: string;
    provinces: IAreaItem [];
    citys: IAreaItem [];
    districts: IAreaItem [];
    authType: number;
    keyWord: string;
    schools: ISchoolTable;
    platForms: IPlatFormsTable;
}

export enum AUTH_TYPE {
    SCHOOL = 1,
    PLATFORM = 2
}
export default AUTH_TYPE;